import {
  FETCH_PETTY_CASH_REQUEST,
  FETCH_PETTY_CASH_SUCCESS,
  FETCH_PETTY_CASH_FAILURE,
  CREATE_PETTY_CASH_REQUEST,
  CREATE_PETTY_CASH_SUCCESS,
  CREATE_PETTY_CASH_FAILURE,
  UPDATE_PETTY_CASH_REQUEST,
  UPDATE_PETTY_CASH_SUCCESS,
  UPDATE_PETTY_CASH_FAILURE,
  DELETE_PETTY_CASH_REQUEST,
  DELETE_PETTY_CASH_SUCCESS,
  DELETE_PETTY_CASH_FAILURE,
  FETCH_PETTY_CASH_SUMMARY_REQUEST,
  FETCH_PETTY_CASH_SUMMARY_SUCCESS,
  FETCH_PETTY_CASH_SUMMARY_FAILURE,
} from '../../Action/PettyCashAction/PettyCashAction';

const initialState = {
  transactions: [],
  summary: null,
  total: 0,
  loading: false,
  actionLoading: false,
  error: null,
};

const pettyCashReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Transactions
    case FETCH_PETTY_CASH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PETTY_CASH_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.transactions,
        total: action.payload.total,
      };
    case FETCH_PETTY_CASH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Transaction
    case CREATE_PETTY_CASH_REQUEST:
      return {
        ...state,
        actionLoading: true,
        error: null,
      };
    case CREATE_PETTY_CASH_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        transactions: [action.payload, ...state.transactions],
        total: state.total + 1,
      };
    case CREATE_PETTY_CASH_FAILURE:
      return {
        ...state,
        actionLoading: false,
        error: action.payload,
      };

    // Update Transaction
    case UPDATE_PETTY_CASH_REQUEST:
      return {
        ...state,
        actionLoading: true,
        error: null,
      };
    case UPDATE_PETTY_CASH_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        transactions: state.transactions.map((transaction) =>
          transaction.id === action.payload.id ? action.payload : transaction
        ),
      };
    case UPDATE_PETTY_CASH_FAILURE:
      return {
        ...state,
        actionLoading: false,
        error: action.payload,
      };

    // Delete Transaction
    case DELETE_PETTY_CASH_REQUEST:
      return {
        ...state,
        actionLoading: true,
        error: null,
      };
    case DELETE_PETTY_CASH_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        transactions: state.transactions.filter(
          (transaction) => transaction.id !== action.payload
        ),
        total: state.total - 1,
      };
    case DELETE_PETTY_CASH_FAILURE:
      return {
        ...state,
        actionLoading: false,
        error: action.payload,
      };

    // Fetch Summary
    case FETCH_PETTY_CASH_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PETTY_CASH_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        summary: action.payload,
      };
    case FETCH_PETTY_CASH_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default pettyCashReducer;